/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetGeoSellersRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {GetGeoSellersResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const getGeoSellers = (request: GetGeoSellersRequest, options?: CashRequestOptions) => post<GetGeoSellersRequest, GetGeoSellersResponse>("/2.0/cash/get-geo-sellers", request, {...options, rejectOnError: true })